export default {
  getBonusWeeks: () => `/pay-periods/bonus-weeks`,
};
